import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { servicesData } from "./servicesData";

interface ServiceDialogProps {
  serviceId: string;
  open: boolean;
  onClose: () => void;
}

const ServiceDialog: React.FC<ServiceDialogProps> = ({
  serviceId,
  open,
  onClose,
}) => {
  const service = servicesData.find((s) => s.sectionLink === serviceId);

  if (!service) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(255, 255, 255, 0.2)",
            backdropFilter: "blur(6px)",
          },
        },
      }}
      fullScreen={false}
    >
      <DialogTitle id={`dialog-title-${service.sectionLink}`}>
        {service.title}
      </DialogTitle>
      <DialogContent dividers>
        {/* Imagem do serviço */}
        {service.imageUrl && (
          <Box
            component="img"
            src={service.imageUrl}
            alt={service.title}
            sx={{
              width: "100%",
              borderRadius: 2,
              mb: 2,
              maxHeight: 250,
              objectFit: "cover",
            }}
          />
        )}

        {/* O que é */}
        <Typography variant="h6" gutterBottom>
          O que é
        </Typography>
        <Typography variant="body1" paragraph>
          {service.whatIsIt}
        </Typography>

        {/* O que resolve */}
        <Typography variant="h6" gutterBottom>
          O que resolve
        </Typography>
        <ul style={{ paddingLeft: "20px" }}>
          {service.whatSolves.map((item: string, i: number) => (
            <li key={i}>
              <Typography variant="body2">{item}</Typography>
            </li>
          ))}
        </ul>

        {/* Resultados esperados */}
        <Typography variant="h6" gutterBottom>
          Resultados esperados
        </Typography>
        <ul style={{ paddingLeft: "20px" }}>
          {service.expectedResults.map((item: string, i: number) => (
            <li key={i}>
              <Typography variant="body2">{item}</Typography>
            </li>
          ))}
        </ul>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ServiceDialog;
